/* Version: 3.5.137 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import InputMask from 'react-input-mask';
import styled from 'styled-components';
import { Root as Root$1, InputValue } from '../Select/styledComponents.js';
import { FocusOutlineInset } from '../../mixins/index.js';
import { rem } from '../../utils/functions.js';
import { jsx } from 'react/jsx-runtime';
import { typography } from '../../typography/typography.js';

var _excluded = ["mask", "maskChar", "formatChars", "inputStyle", "textAlign", "theme"];
var Input = /*#__PURE__*/styled(/*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var mask = _ref.mask,
    maskChar = _ref.maskChar,
    formatChars = _ref.formatChars;
    _ref.inputStyle;
    var textAlign = _ref.textAlign;
    _ref.theme;
    var rest = _objectWithoutProperties(_ref, _excluded);
  if (mask) {
    return /*#__PURE__*/jsx(TextFieldInput, _objectSpread(_objectSpread({}, rest), {}, {
      as: InputMask,
      formatChars: formatChars,
      inputRef: ref,
      mask: mask,
      maskChar: maskChar,
      $textAlign: textAlign
    }));
  }
  return /*#__PURE__*/jsx(TextFieldInput, _objectSpread(_objectSpread({
    as: "input",
    $textAlign: textAlign
  }, rest), {}, {
    ref: ref
  }));
})).withConfig({
  displayName: "styledComponents__Input",
  componentId: "sc-k03yft-0"
})(["", ""], function (_ref2) {
  var inputStyle = _ref2.inputStyle;
  return inputStyle;
});
process.env.NODE_ENV !== "production" ? Input.displayName = 'Input' : undefined;
/* eslint-enable react/prop-types */

var LabelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LabelWrapper",
  componentId: "sc-k03yft-1"
})(["display:inline-flex;flex-direction:row;align-items:baseline;justify-content:space-between;width:100%;"]);
process.env.NODE_ENV !== "production" ? LabelWrapper.displayName = 'LabelWrapper' : undefined;
var OptionalText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__OptionalText",
  componentId: "sc-k03yft-2"
})(["font-family:", ";font-size:", ";font-weight:", ";color:", ";line-height:", ";text-transform:uppercase;"], typography.fontFamily, typography.fontSizeSmall, typography.fontWeightDemibold, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, typography.lineHeight);
process.env.NODE_ENV !== "production" ? OptionalText.displayName = 'OptionalText' : undefined;
var Root = /*#__PURE__*/styled(Root$1).withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-k03yft-3"
})(["display:inline-block;position:relative;", ""], function (_ref4) {
  var rootStyle = _ref4.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : undefined;
var ShowPasswordToggleWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ShowPasswordToggleWrapper",
  componentId: "sc-k03yft-4"
})(["align-items:center;display:flex;justify-content:center;background:transparent;border:none;cursor:pointer;color:", ";font-family:", ";font-weight:", ";font-size:", ";margin:0 ", ";outline:2px solid transparent;outline-offset:0;padding:", " ", ";:hover,:focus{text-decoration:none;color:", ";}:focus-visible{", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
}, typography.fontFamily, typography.fontWeightDemibold, typography.fontSizeSmall, rem(6), rem(8), rem(12), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, FocusOutlineInset);
process.env.NODE_ENV !== "production" ? ShowPasswordToggleWrapper.displayName = 'ShowPasswordToggleWrapper' : undefined;
var TextFieldInput = /*#__PURE__*/styled(InputValue).withConfig({
  displayName: "styledComponents__TextFieldInput",
  componentId: "sc-k03yft-5"
})(["border:none;text-align:", ";&[data-forceuppercase='true']{text-transform:uppercase;}::placeholder{text-transform:none;}&[list]::-webkit-calendar-picker-indicator{display:none !important;}"], function (_ref7) {
  var $textAlign = _ref7.$textAlign;
  return $textAlign;
});
process.env.NODE_ENV !== "production" ? TextFieldInput.displayName = 'TextFieldInput' : undefined;

export { Input, LabelWrapper, OptionalText, Root, ShowPasswordToggleWrapper, TextFieldInput };
